import Chart from './chart/Main.vue'
import BarChart from './barchart/Main.vue'
import GoogleMapLoader from './google-map-loader/Main.vue'
import Highlight from './highlight/Main.vue'
import Litepicker from './litepicker/Main.vue'
import Tippy from './tippy/Main.vue'
import TippyContent from './tippy-content/Main.vue'
import TomSelect from './tom-select/Main.vue'
import LoadingIcon from './loading-icon/Main.vue'
import TinySlider from './tiny-slider/Main.vue'
// import ClassicEditor from './ckeditor/ClassicEditor.vue'
// import BalloonBlockEditor from './ckeditor/BalloonBlockEditor.vue'
// import BalloonEditor from './ckeditor/BalloonEditor.vue'
import DocumentEditor from './ckeditor/DocumentEditor.vue'
// import InlineEditor from './ckeditor/InlineEditor.vue'
import Dropzone from './dropzone/Main.vue'
import FullCalendar from './calendar/Main.vue'
import FullCalendarDraggable from './calendar/Draggable.vue'
import DisabilityIcon from "./disability-icon/Main.vue"
import NeetsIcon from "./neets-icon/Main.vue"
import FormIcon from "./form-icon/Main.vue"
import * as featherIcons from '@zhuowenli/vue-feather-icons'
import vSelect from 'vue-select'
import AlertCustom from './alert/Main.vue'
import ArrowDollarIcon from './icons/ArrowDollarIcon.vue'
import CircleXIcon from './icons/CircleXIcon.vue'
import AutismIcon from './icons/AutismIcon.vue'
import BookOpenBgIcon from './icons/BookOpenBgIcon.vue'
import CircleDollarSignBgIcon from './icons/CircleDollarSignBgIcon.vue'
import CirclePlusBgIcon from './icons/CirclePlusBgIcon.vue'
import DeptIcon from './icons/DeptIcon.vue'
import DisabilityNewIcon from './icons/DisabilityNewIcon.vue'
import DrinkingWaterIcon from './icons/DrinkingWaterIcon.vue'
import EarsIcon from './icons/EarsIcon.vue'
import ElectricityIcon from './icons/ElectricityIcon.vue'
import EyesIcon from './icons/EyesIcon.vue'
import InternetIcon from './icons/InternetIcon.vue'
import MentallyIcon from './icons/MentallyIcon.vue'
import PatientIcon from './icons/PatientIcon.vue'
import PropertyIcon from './icons/PropertyIcon.vue'
import SavingIcon from './icons/SavingIcon.vue'
import WaterForUseIcon from './icons/WaterForUseIcon.vue'
import HouseIcon from './icons/HouseIcon.vue'
import MemberIcon from './icons/MemberIcon.vue'
import EducationIcon from './icons/EducationIcon.vue'
import FemaleIcon from './icons/FemaleIcon.vue'
import HandIcon from './icons/HandIcon.vue'
import MaleIcon from './icons/MaleIcon.vue'
import PeopleIcon from './icons/PeopleIcon.vue'
import SingleUserIcon from './icons/SingleUserIcon.vue'
import CircleCheckedIcon from './icons/CircleCheckedIcon.vue'
import BrainIcon from './icons/BrainIcon.vue'
import DevelopmentIcon from './icons/DevelopmentIcon.vue'
import DiseaseIcon from './icons/DiseaseIcon.vue'
import HealIcon from './icons/HealIcon.vue'
import VaccineIcon from './icons/VaccineIcon.vue'
import BagIcon from './icons/BagIcon.vue'
import DeptAltIcon from './icons/DeptAltIcon.vue'
import DollarSignBagIcon from './icons/DollarSignBagIcon.vue'
import SavingBagIcon from './icons/SavingBagIcon.vue'
import AllGenderIcon from './icons/AllGenderIcon.vue'

export default app => {
  app.component('Chart', Chart)
  app.component('BarChart', BarChart)
  app.component('GoogleMapLoader', GoogleMapLoader)
  app.component('Highlight', Highlight)
  app.component('Litepicker', Litepicker)
  app.component('Tippy', Tippy)
  app.component('TippyContent', TippyContent)
  app.component('TomSelect', TomSelect)
  app.component('LoadingIcon', LoadingIcon)
  app.component('TinySlider', TinySlider)
  app.component('Dropzone', Dropzone)
  // app.component('ClassicEditor', ClassicEditor)
  // app.component('BalloonBlockEditor', BalloonBlockEditor)
  // app.component('BalloonEditor', BalloonEditor)
  app.component('DocumentEditor', DocumentEditor)
  // app.component('InlineEditor', InlineEditor)
  app.component('FullCalendar', FullCalendar)
  app.component('FullCalendarDraggable', FullCalendarDraggable)
  app.component('v-select', vSelect)
  app.component('DisabilityIcon', DisabilityIcon)
  app.component('NeetsIcon', NeetsIcon)
  app.component('AlertCustom', AlertCustom)
  app.component('FormIcon', FormIcon)
  app.component('ArrowDollarIcon', ArrowDollarIcon)
  app.component('CircleXIcon', CircleXIcon)
  app.component('AutismIcon', AutismIcon)
  app.component('BookOpenBgIcon', BookOpenBgIcon)
  app.component('CircleDollarSignBgIcon', CircleDollarSignBgIcon)
  app.component('CirclePlusBgIcon', CirclePlusBgIcon)
  app.component('DeptIcon', DeptIcon)
  app.component('DisabilityNewIcon', DisabilityNewIcon)
  app.component('DrinkingWaterIcon', DrinkingWaterIcon)
  app.component('EarsIcon', EarsIcon)
  app.component('ElectricityIcon', ElectricityIcon)
  app.component('EyesIcon', EyesIcon)
  app.component('InternetIcon', InternetIcon)
  app.component('MentallyIcon', MentallyIcon)
  app.component('PatientIcon', PatientIcon)
  app.component('PropertyIcon', PropertyIcon)
  app.component('SavingIcon', SavingIcon)
  app.component('WaterForUseIcon', WaterForUseIcon)
  app.component('HouseIcon', HouseIcon)
  app.component('MemberIcon', MemberIcon)
  app.component('EducationIcon', EducationIcon)
  app.component('FemaleIcon', FemaleIcon)
  app.component('HandIcon', HandIcon)
  app.component('MaleIcon', MaleIcon)
  app.component('PeopleIcon', PeopleIcon)
  app.component('SingleUserIcon', SingleUserIcon)
  app.component('CircleCheckedIcon', CircleCheckedIcon)
  app.component('BrainIcon', BrainIcon)
  app.component('DevelopmentIcon', DevelopmentIcon)
  app.component('DiseaseIcon', DiseaseIcon)
  app.component('HealIcon', HealIcon)
  app.component('VaccineIcon', VaccineIcon)
  app.component('BagIcon', BagIcon)
  app.component('SavingBagIcon', SavingBagIcon)
  app.component('DollarSignBagIcon', DollarSignBagIcon)
  app.component('DeptAltIcon', DeptAltIcon)
  app.component('AllGenderIcon', AllGenderIcon)

  for (const [key, icon] of Object.entries(featherIcons)) {
    icon.props.size.default = '24'
    app.component(key, icon)
  }
}
